import { X } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import Uploader from "@/admin/Uploader";
import { Panel, useFetch, KIND, fmtSize } from "@/admin/ui";

export default function ModuleMedia({ media, onChange }) {
  const { data: files, setData } = useFetch("/admin/files");
  const byId = Object.fromEntries((files || []).map((f) => [f.id, f]));
  const available = (files || []).filter((f) => !media.includes(f.id) && f.kind !== "image");
  return (
    <Panel title="Archivos del módulo" testid="admin-module-media">
      {!media.length && <div className="adm-sub" style={{ marginBottom: ".75rem" }}>Sin archivos. Añade vídeo, audio o PDF.</div>}
      {media.map((id) => (
        <div key={id} className="adm-list-item" data-testid={`admin-module-media-${id}`}>
          <span>{byId[id]?.name || "Archivo"}<div className="adm-sub">{KIND[byId[id]?.kind] || ""} {byId[id] ? `· ${fmtSize(byId[id].size)}` : ""}</div></span>
          <button className="adm-btn sm" onClick={() => onChange(media.filter((m) => m !== id))} aria-label="Quitar" data-testid={`admin-module-media-remove-${id}`}><X size={14} /></button>
        </div>
      ))}
      {available.length > 0 && (
        <div style={{ margin: ".75rem 0" }}>
          <Select value="" onValueChange={(v) => onChange([...media, v])}>
            <SelectTrigger className="bg-white" data-testid="admin-module-media-pick"><SelectValue placeholder="Añadir desde la biblioteca" /></SelectTrigger>
            <SelectContent>{available.map((f) => <SelectItem key={f.id} value={f.id}>{f.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      )}
      <Uploader accept="video/*,audio/*,application/pdf" label="Subir vídeo, audio o PDF" hint="Vídeo, audio o PDF · máximo 600 MB" testid="admin-module-uploader"
        onUploaded={(f) => { setData([f, ...(files || [])]); onChange([...media, f.id]); }} />
      <div className="adm-help">Los cambios se aplican al pulsar Guardar cambios.</div>
    </Panel>
  );
}
